export default class PosterUtil {
  readonly beginX = 15
  beginY = 100
  readonly avatarURI = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAACM5JREFUaEO1WXtQVOcV/527D2AX2OWpCVbA+CAqJmh9VhM16pjomJq0WttOMpPp2OkjNUCnNhEsAaKTNizWsY/EybRNmjRJra/o5GGKEhVUwAfGiqKpKIgosLu8996997S7CvLYx72r3Jn9Z7/z+53z++73fed85xLu09P6RuFcQcdPEZDETEmAksSgJPLycyNA18FoBOG6jlB21Snvm5SXJ96r+9v8IT4ttoIlOubFIFoFYLQWGgJ6mOh9KPgcEbrPrT992a4F32sbkgBHcf7a/8/oWjCmheJ0MIYI1wG8pYfwljlzQ6MWTk0C7nfgvoQoirLdKOjfVCtElQCnbfNYhvtPABZpmZ3QbekSEb1kydywPxhHUAHO4lefZAjvghEXjGwYxn9kzcp9OxBvQAHO4oIXmbF1GAJTT0m03pqZ81t/AL8CHEWF3wXxR+o9DZ8lAy/EZOX+xZcHnwJabfnpAqh6+ELSzswsLIzJ3nBwyMYf/Efbtk1xLMqlDEzS7mZ4EaTwDMsvN1b09zLkDThs+TsAenZ4QwmRnbnGTcKi+KycBp+JzFFU+CyId4RI74WRQC7DaLGCTLIbYJ3cLsncY9CjRx8ptxsevRduD1YAbYrOytngW4AtvwSgBaE4EcK4yfCQ67w+3j0WAkZ5OJj5mNwszurjY9Rzt+Gy1GBOZVGnqfToF5NTkjAzYX3uBe+E9Q7YbYXPE/ivoQQfluYq1Y+U0gCMGIBnVLqbXd8cwsl0Q24Ju+huMj8Wij8CbbVk5awbIMBRVHAChOlaCU1zOk6SEVN94djNZbJdnOOPk0VduVhrna3VJwAZJMywZm446X0DbVsKlisKPtZKFDax55A+0T3fH05pkyoUlxJwUkIWwXjFmp272SvAYSt8E+C1WgQYU8XDhmRxnj8MAZelW66H1HByh6FUrIt+XI1tnw3RAWtmzhKvAGdxQQMzHtRCYJrXcZ50eNj/8pBLZKd7oVpO8VrUKW4zZqi19yyjLrMcTY6iV58ACV9oAMKQLB41porfCoBpYTGhQXbWT1HLyy5duXhJ234QQCvIUVywCYyX1Try2JlmdR6ncJ7pDyNYF1xg89QJ4tniCpK7VR0MBLh6zsV5VoRRdSyEzeQsLvgbM55TDQJgnt/h39yUXk4xS/pOFun8n0vgalW1lOSGqCq3w6j6lkeEd8hhK/wC4CfUChDC+EbE7M6RvuzJNOlDxCxdPXhMuXHkiNJcEcXu7kcC+VFumo5KtyICLc1BcPo3OWz55wHyJCFVjyE17ooxuS5liHH4hE8obvmTAQNsrjom3yzXkdg+kcHmwbZya3ipu9Gs4TTiGrLbCtoIiFIVvSd1R1uvmuanNKGjyuDFRIztEUyT4tiYNE4tBxSpS2mrvaTYa9rQUReJ8Lg2wTpZ724iFs+cUP0GGGgnh63A086wqnYOIHLN2noI5K137ufT/dnuy3Jzk6rcccevwyPgNICAa3NwkKblq74ULDEh1TF+BSvK1Y5/bNda4J32nEJ7mLFCy0yGTZ970DB+UkhVqz8/SruzrGvvB37rJp84wm6yFxVsJcKLWgQICYm15iUrR7KGvROMX6yuLBfPVmkq7IhoC7UVF2YpzEXBHAweN06bU21MS1edaQOeTi03q7s+3aWZi5kz6V5uYaan11wQIqMnaBU/wJ6V1o73t8eGwsEKVlLrlt+MFhS9pwNhCYUk8gc/DgXWh+nav+Om4mhJDIkkXB97u5wuLvgjGD8JicRTWiz7zi6yxq3Ugme3u7Jr999HscvlM6sH42Lw/pisjcu9Ary9fYEPBwMFGjdOzthrnDJ9NogSgvHI9Vf2dpd+punkG8LJ9D1rds6H/e7E+fsItCyY80DjQlzCBX3quFr9g8ldQpQlHuDJBBAD5yG66qT/1ibJt25Y3HWXVRdsvv3RFWtWTqpnrE+A05b/fQa9F7KA9DF1hk693ThvQZcuOiYeOt34AVySdJzd7jBX5dEuqbNpAtdcuZdm8e+sWbm/GiDAuxdshSUAa0pQbjPXN2fIl7oTlflJsWvOxkempQeahIaWytMd4nFWmm8h/ow+OqyZtJQOnhlv1TEvjMzeeGaIgDt7oQTA7UItyNP6iFzqHCNPBMG77neVv3bNahp9fc1jexJHWNK9r7j36ZbszncPLa2+3lo5b2nGutaI8Cjv0Rlxk0pHHjGorkCJ8HNLZu4fenl9tBYLfw3w5mDB1y+WyqQo7kv9jfaLp4/VfHS780bkzEh5vvrpGW97L/0nLm4rP3D2lVjJ3enNGbPSVp1+IGZ8X5dOkOir5I8Nk4P5JOADS1bumv52PrvTdlvgDV2/VDoumQZeKQcIuOMhIiz2P9aIFHuj4+SAEnmwgN6AUncGuE0S6knAQsu63NqgAhzFr00FK56lNCS5tY9RjjU/6r7bLrzDNliAQWf8amba6vAwgzni8Ll3mkWpq6/i9SfAXC8cSjyh99lnEoAXon18I/D7gcP+RsG3SYf3wDD1KhZj+WLDfMnTPvSZtXeVv2YHOCbBklI6O231DJ1giOjFnrq8v/TKzVPetb4442f1keExPu8TMWd1ZdZa3YCqlIAsS1Zusa8lFvgTU1HhLCbeA8Cb6pvmuku6EhW/F/RPqn5f+fCoeXLKiKk+OxYNLeeqTn/9qW7Z9Gy/XWpBxKnkff36Q0yrrNk5//S3P4J+5GvfuilBluRyORwjrz0ltjLhG8E2272Oj6jQV5muCdNk4jlxmRvLA/EFFdAL/vpA3pfOcbLfVuK9Bt0fb3RSaWqp+YemX6yvD8arWoCH6GRd7nPEeAmAlhZgsBjujhOaobAtIjJqW1rC+nY1QE0CPIQ1t16P6uxozybQM0QImHXVBNB7iAG0U8fCtimpeTUacHdrIS2gXtuTV3NWEAvPgHkJgAc0cnQDOMjgncT6f2Wk5jk04r3mmt+ALycHD+bprSnuuSBhEREeZ3AMgN6fB+Jp3dgJZGeFyxRQieQWymeNy2sLJej+mP8BVZBbSVia6MoAAAAASUVORK5CYII='

  constructor(protected ctx: CanvasRenderingContext2D, protected width: number, protected height: number, protected QRWidth: number) {}

  get QRLeft() {
    return Math.ceil((this.width - this.QRWidth) / 2)
  }

  get QRTop() {
    return this.height - this.QRWidth - 20
  }

  drawBackground() {
    this.ctx.fillStyle = '#f1f1f1'
    this.ctx.fillRect(0, 0, this.width, this.height)
    this.ctx.save()
  }

  drawIntro(title: string, description: string) {
    this.ctx.font = "bold 18px Arial"
    this.ctx.fillStyle = '#333'
    this.ctx.fillText(title, this.beginX, 30)

    this.ctx.font = "16px Arial"
    this.ctx.fillStyle = '#666'
    this.wrap(description, this.beginX, 60)
    this.ctx.save()
  }

  async drawInviter(name: string) {
    const beginY = this.beginY + 10
    this.ctx.font = "bold 14px Arial"
    this.ctx.fillStyle = '#353535'
    this.ctx.fillText('邀请人', this.beginX, beginY)
  
    this.ctx.font = "14px Arial"
    this.ctx.fillText(name, this.beginX + 60, beginY + 40)
  
    const avatar = await this.loadImage(this.avatarURI)
    this.ctx.drawImage(avatar, this.beginX, beginY + 10)
    this.ctx.save()
  }

  async drawQrCode(data: string) {
    // const BGWidth = this.QRWidth + 10
    // this.ctx.fillStyle = '#fff'
    // this.ctx.fillRect(this.QRLeft - 5, this.QRBottom - 5, BGWidth, BGWidth)

    this.ctx.drawImage(await this.loadImage(data), this.QRLeft, this.QRTop, this.QRWidth, this.QRWidth)
  }

  protected async loadImage (url: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject)=> {
      const img = new Image()
      img.src = url
      img.onload = ()=> {
        resolve(img)
      }
      img.onerror = (err)=> {
        reject(err)
      }
    })
  }

  protected wrap(text: string, x: number, y: number) {
    let line = '';
    const maxWidth = this.width - 30
    const lineHeight = this.ctx.measureText('M').width * 1.6;
    text.split('').forEach((word)=> {
      const measure = this.ctx.measureText(line)
      if (measure.width > maxWidth) {
        this.ctx.fillText(line, x, y)
        line = ''
        y += lineHeight
      } else {
        line += word
      }
    })
    this.ctx.fillText(line, x, y);
    this.beginY = y + lineHeight
  }
}